import { useMetrics, useReports } from '@sail/observability';
import { getEnvironment } from '@sail/utils';
import { useCallback } from 'react';
import { useNavigationConfig } from '../internal/config/NavigationConfigContext';
import routeToUrl from '../internal/routeToUrl';
const FALLBACK_PATH = '/';
const emitedRouteMetrics = {};
export default function useRouteToUrl() {
    const config = useNavigationConfig();
    const { increment } = useMetrics();
    const { warning } = useReports();
    return useCallback((route, base)=>{
        try {
            return routeToUrl(config, route, base);
        } catch (error) {
            if (getEnvironment() !== 'production') {
                throw error;
            }
            warning(error, {
                tags: {
                    metric: 'stripelets.navigation.cannot_generate_route'
                },
                extras: {
                    route,
                    base
                }
            });
            if (!emitedRouteMetrics[route.name]) {
                emitedRouteMetrics[route.name] = true;
                increment('stripelets.navigation.cannot_generate_route');
            }
            return FALLBACK_PATH;
        }
    }, [
        config,
        increment,
        warning
    ]);
}

//# sourceMappingURL=useRouteToUrl.js.map